import * as analytics from 'analytics/Analytics';
import {
  StructuredTableKind,
  UnknownStructuredTable,
} from 'notebook/structured-tables/StructuredTableConstants';
import {ColumnConstraint} from 'notebook/tables/TableConstants';
import {FileAnalyticsParams, getFileAnalyticsMetadata} from 'notebook/util/analytics/FileAnalyticsUtils';

/**
 * Information required for analytics events related to structured tables.
 */
export interface StructuredTableAnalyticsParams {
  structuredTableKind: StructuredTableKind;
  structuredTableProvenanceUuid: string;
}

/**
 * Format the table kind as a source type for analytics events.
 */
export function getSourceTypeForStructuredTable(table: UnknownStructuredTable): string {
  return `${table.kind}_structured_table`.toLowerCase();
}

export function logColumnAnalytics({
  columnConstraint,
  analyticsEvent,
  structuredTableAnalyticsParams,
  fileAnalyticsParams,
  additionalMetadata,
}: {
  analyticsEvent: analytics.AnalyticsEvent;
  columnConstraint?: ColumnConstraint;
  structuredTableAnalyticsParams: StructuredTableAnalyticsParams | null;
  fileAnalyticsParams: FileAnalyticsParams | null;
  additionalMetadata?: object;
}): void {
  // Only log analytics for structured table columns.
  if (columnConstraint?.structuredTableColumn) {
    analytics.trackEvent(analyticsEvent, {
      ...getFileAnalyticsMetadata(fileAnalyticsParams),
      ...additionalMetadata,
      // Table analytics
      table_type: structuredTableAnalyticsParams ? 'STRUCTURED' : 'LEGACY',
      structured_table_kind: structuredTableAnalyticsParams?.structuredTableKind ?? null,
      structured_table_provenance_uuid: structuredTableAnalyticsParams?.structuredTableProvenanceUuid ?? null,
      // Column analytics
      column_type: columnConstraint.structuredTableColumn.columnType ?? null,
      column_name: columnConstraint.structuredTableColumn.name ?? null,
      column_id: columnConstraint.structuredTableColumn.id ?? null,
      column_group: columnConstraint.columnDefinition?.columnGroup ?? null,
      schema_field_api_id: columnConstraint.structuredTableColumn.schemaFieldApiId ?? null,
    });
  } else {
    analytics.trackEvent(analyticsEvent, {
      ...getFileAnalyticsMetadata(fileAnalyticsParams),
      ...additionalMetadata,
      // Table analytics
      table_type: 'PLAIN',
    });
  }
}
